import React from "react";

const DraftAppointment = () => {
  return (
    <div>
      <h3 className="text-lg font-bold">Appointment Drafts</h3>
      <p>Appointment Drafts Content goes here.</p>
    </div>
  );
};

export default DraftAppointment;